import React from "react";
import { NavIconT } from "types/utils";
import styles from "./MainNav.module.less";

const Leads = ({
  height = "21",
  width = "21",
  active = false,
  hovered = false,
  fill = "var(--royal-peacock-blue)",
}: NavIconT) => {
  return (
    <div
      className={[active ? styles.navIconContainerActive : styles.navIconContainer, hovered ? styles.hovered : []].join(
        " ",
      )}
      style={{ marginBottom: "2px" }}
    >
      <svg width={width} height={height} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 2H20L13 11V15L10.5 17L8 15V11Z" fill={fill} />
      </svg>
    </div>
  );
};

export default Leads;
